import TextInputField, { TextInputFieldProps } from "./TextInputField";

export { TextInputFieldProps };
export default TextInputField;
